import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

// clipboard
Vue.use(VueClipboard)

Vue.prototype.$copyToClipboard = function (text) {
  let valueToCopy = text
  if (typeof valueToCopy !== 'string') {
    valueToCopy = String(valueToCopy)
  }
  this.$copyText(valueToCopy)
}
